import { render, staticRenderFns } from "./BusinessPromptPage.vue?vue&type=template&id=4f36fa16&scoped=true"
import script from "./BusinessPromptPage.vue?vue&type=script&lang=js"
export * from "./BusinessPromptPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessPromptPage.vue?vue&type=style&index=0&id=4f36fa16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36fa16",
  null
  
)

export default component.exports